export class ArraySort {
    public static sort(
        dataCollection: any[],
        property: string,
        ascending: boolean,
        secondaryProperty?: string,
        secondaryAscending: boolean = true,
        language: string = 'nb-no'
    ) {
        if (!dataCollection) {
            return;
        }

        dataCollection.sort((a, b) => {
            const comparer = this.compareProperty(a[property], b[property], ascending, language);
            if (comparer !== 0) {
                return comparer;
            }

            if (comparer === 0 && secondaryProperty != null) {
                return this.compareProperty(a[secondaryProperty], b[secondaryProperty], secondaryAscending, language);
            }

            return 0;
        });
    }

    private static compareProperty(a: any, b: any, ascending: boolean, language: string) {
        if (typeof a === 'string') {
            if (a !== b) {
                const collator = new Intl.Collator(language, { numeric: true, sensitivity: 'base' });
                const comparer = a.localeCompare(b, language, collator.resolvedOptions() as Intl.CollatorOptions);
                return this.setDirection(comparer, ascending);
            }
            return 0;
        } else {
            if (a !== b) {
                const comparer: number = this.compareBoolAndNumber(a, b);
                return this.setDirection(comparer, ascending);
            }
            return 0;
        }
    }

    private static compareBoolAndNumber(a: any, b: any): any {
        // remove undefined and null type as it messes up secondary sorting
        if (a == null && typeof b === 'boolean') {
            a = false;
        } else if (a == null && typeof b === 'number') {
            a = 0;
        } else if (b == null && typeof a === 'boolean') {
            b = false;
        } else if (b == null && typeof a === 'number') {
            b = 0;
        }

        if (a > b) {
            return 1;
        } else if (a < b) {
            return -1;
        }
        return 0;
    }

    private static setDirection(comparer: number, ascending: boolean) {
        if (ascending) {
            return comparer;
        } else {
            return comparer !== 0 ? comparer * -1 : 0;
        }
    }
}
